<script>
import Banner from '../components/PageBanner';
import TabMenu from '../components/PageTabMenu';
import Tab from '../components/PageTab';
import Spinner from '../components/Spinner';
import Footer from '../components/Footer';
import Modale from "../components/Modale"
import ModalYesNo from "../components/ModalYesNo"
import ButtonWithLoading from "../components/ButtonWithLoading"
import Menu from "../components/Menu"
import SearchPredictive from "../components/SearchPredictive"

export default {
  name: 'PageTemps',
  components :{
    Banner,
    TabMenu,
    Tab,
    Spinner,
    Footer,
    Modale,
    ModalYesNo,
    ButtonWithLoading,
    Menu,
    SearchPredictive,
  },
  data(){
    return{
      fullyLoaded: false,
      contacts: [], //Tous les contacts
      contact: {}, //le contact selectionné
      contactsDisplayed: [], //Les contacts affichés dans le tableau central
      isModaleAddContactVisible: false,
      isModaleDeleteVisible: false,
      modaleInfos: {}, //Si je doit déclarer certaines propriétés dans data, bien les déclarer également dans closeModale()
      updateLoading: false, //La requête serveur de mise à jour est en cours
      contactsLabels: [], //Les labels de l'agence
      selectedLabel: "", //Le label sélectionné, celui à partir duquel je tri les contacts affichés
      isLabelMenuVisible: {_id: ""}, //L'id du label pour lequel le menu est visible.
      isModaleCreateLabelVisible: false,
      isModaleUpdateLabelVisible: false,
      isAddLabelToContactMenuVisible: false,
      isModaleDeleteLabelVisible: false,
    }
  },

  /////////////////////////////////
  //          Mounted            //
  /////////////////////////////////

  async mounted(){
    this.load()
  },

  /////////////////////////////////
  //         Watchers            //
  /////////////////////////////////
  watch: {
    // 'contact'(newVal, oldVal) {
    //   if (newVal != oldVal){
    //     console.log("different")
    //     // this.$axios.get('contractualise/getByPhase/' + this.phase._id)
    //     // .then(response => {
    //     //   this.contractualises = response.data
    //     // })
    //     // .catch(err => console.log(err))
    //   } else {
    //     console.log("same")
    //   }
    // }
  },

  /////////////////////////////////
  //         Computed            //
  /////////////////////////////////
  computed:{
    contactObserver(){
      //S'il y a un contact de sélectionné (au moins une propriété à l'objet this.contact)
      if(Object.values(this.contact).length){
        let differences = this.compare(this.contacts.find(e => e._id == this.contact._id), this.contact)

        if (differences.length == 0){
          // if (document.getElementById("updateContactButton")){
          //   document.getElementById("updateContactButton").classList.add("detail-footer-container-bouton-unchanged")
          // }
          return true
        } else {
          // if (document.getElementById("updateContactButton")){
          //   document.getElementById("updateContactButton").classList.remove("detail-footer-container-bouton-unchanged")
          // }
          return false
        }
      } else {
        return false
      }
    },
    labelsInAddMenu(){
      let myArray = []

      for (let item of this.contactsLabels){
        if (this.contact.labels.indexOf(item._id) == -1){
          myArray.push(item)
        }
      }

      return myArray
    },
    searchPlaceholder(){
      if (this.selectedLabel == ""){
        return "Rechercher..."
      } else {
        return "Rechercher dans " + this.populateLabel(this.selectedLabel).name + "..."
      }
    },
    // Recréer un tableau d'objets avec _id et une string qui correspond à la fois au propriétés sur lesquelles je fais la recherche et à la fois à ce qui sera affiché dans le menu prédictif
    arrayForSearch(){
      let myArray = []
      for (let item of this.contacts){
        let myString = ""
        if (item.name){myString += item.name}
        if (item.surname){myString += " " + item.surname}
        if (item.organisation){myString += " - " + item.organisation}

        let myItem = {
          _id: item._id,
          stringLine: myString,
        }
        myArray.push(myItem)
      }
      return myArray
    }
  },

  /////////////////////////////////
  //          Methods            //
  /////////////////////////////////

  methods:{

    async load (){
      this.fullyLoaded = false;
      const promiseContacts = this.$axios.get('contacts/getByAgence/' + this.$store.state.auth.currentAgence._id).then(response => this.contacts = response.data).catch(err => this.alert(err))
      const promiseContactsLabels = this.$axios.get('contactsLabels/getByAgence/' + this.$store.state.auth.currentAgence._id).then(response => this.contactsLabels = response.data).catch(err => this.alert(err))
      const promisePhaseLabels = this.$axios.get('phaseLabels/getAll/' + this.$store.state.auth.currentAgence._id)
        .then(response => {
          this.phaseList = response.data
        })
      await Promise.all([promiseContacts, promiseContactsLabels, promisePhaseLabels])
      this.contactsDisplayed = this.contacts
      this.fullyLoaded = true;
    },

    addContact(){
      //Vérification du formulaire (très courte pour l'instant....)
      let isOk = true

      if (!this.modaleInfos.name){
        isOk = false
        document.getElementById("prenom").classList.add("error")
        this.alert("Le champ 'Prénom' est requis")
      }

      //Reformatage
      if (this.modaleInfos.name){this.modaleInfos.name = this.modaleInfos.name.trim().replace(/^\w/, (c) => c.toUpperCase())} //Enlever les éventuels espace avant le nom et mettre la première lettre en majuscule
      if (this.modaleInfos.surname){this.modaleInfos.surname = this.modaleInfos.surname.trim().replace(/^\w/, (c) => c.toUpperCase())} //Enlever les éventuels espace avant le nom et mettre la première lettre en majuscule
      if (this.modaleInfos.organisation){this.modaleInfos.organisation = this.modaleInfos.organisation.trim().replace(/^\w/, (c) => c.toUpperCase())} //Enlever les éventuels espace avant le nom et mettre la première lettre en majuscule
      if (this.modaleInfos.city){this.modaleInfos.city = this.modaleInfos.city.trim().replace(/^\w/, (c) => c.toUpperCase())} //Enlever les éventuels espace avant le nom et mettre la première lettre en majuscule

      //Envoi en BDD
      if (isOk) {
        let item = {
          agenceId:     this.$store.state.auth.currentAgence._id,
          created:      Date.now(),
          createdBy:    this.$store.state.auth.currentUser._id,
          name:         this.modaleInfos.name,
          surname:      this.modaleInfos.surname,
          labels:       [],
          email:        this.modaleInfos.email,
          organisation: this.modaleInfos.organisation,
          fonction:     this.modaleInfos.fonction,
          phone1:       this.modaleInfos.phone1,
          phone1Label:  this.modaleInfos.phone1Label,
          phone2:       this.modaleInfos.phone2,
          phone2Label:  this.modaleInfos.phone2Label,
          address:      this.modaleInfos.address,
          code:         this.modaleInfos.code,
          city:         this.modaleInfos.city,
          siret:        this.modaleInfos.siret,
          comment:      this.modaleInfos.comment,
        }

        this.$axios.post('contacts/register/', item)
        .then(res => {
          this.contacts.push(res.data.contact)
          this.contacts.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
          this.alert(res)
          this.contact = res.data.contact
          this.closeModale();
        })
        .catch(err => this.alert(err))
      }
    },
    selectContact(id){
      this.closeModale()
      //Si je fais directement this.contact = this.contacts.find(), il associe les deux > si je modifie contact, il modifie aussi contacts et je pard l'antériorité
      //Je les sépare pour pouvoir annuler les modifications, et les enregistrer si en comparant je vois que contact est différent de contacts.find()
      this.contact = {...this.contacts.find(e => e._id == id)}
      console.log(this.contact)
    },
    deleteContact(id){
      //Je commence par supprimer this.contact, sinon l'observer va bugger
      this.contact = {}

      this.$axios.delete('contacts/'+ id)
      .then(res => {
        this.alert(res)
        //Supprimer l'élément chez le client aussi
        this.contacts.splice(this.contacts.findIndex(e => e._id == id), 1)
        this.closeModale();
      })
      .catch(err => this.alert(err))
      this.load()
    },
    updateContact(id){
      this.contact.updated = Date.now()
      this.contact.updatedBy = this.$store.state.auth.currentUser._id
      this.updateLoading = true

      this.$axios.put('contacts/'+ id, this.contact)
      .then(res => {
        this.alert(res)
        this.contacts.splice(this.contacts.findIndex(e => e._id == this.contact._id), 1, {...this.contact})
        this.updateLoading = false
      })
      .catch(err => this.alert(err))

      console.log(this.contact)
    },
    isNumeric(evt){
      evt.target.value = evt.target.value.replace(/[^0-9+]/g, '')
    },
    closeModale(){
      this.isModaleAddContactVisible = false;
      this.isModaleDeleteVisible = false;
      this.isModaleCreateLabelVisible = false;
      this.isModaleUpdateLabelVisible = false;
      this.isLabelMenuVisible = {_id: ""};
      this.isAddLabelToContactMenuVisible = false;
      this.isModaleDeleteLabelVisible = false;
      this.modaleInfos = {}
    },
    removeError(id){
      document.getElementById(id).classList.remove('error')
    },
    showLabelMenu(id){
      this.isLabelMenuVisible._id = id
    },
    createLabel(){
      this.modaleInfos.color = "#000000"
      this.isModaleCreateLabelVisible = true
    },
    addLabel(){
      if (!this.modaleInfos.labelName){
        this.alert("Veuillez entrer un nom de label")
      } else {
        let item = {
          agenceId:     this.$store.state.auth.currentAgence._id,
          created:      Date.now(),
          createdBy:    this.$store.state.auth.currentUser._id,
          name:         this.modaleInfos.labelName,
          color:        this.modaleInfos.color,
          //le rank est géré sur le serveur
        }

        this.$axios.post('contactsLabels/register/', item)
        .then(res => {
          item._id = res.data.contactLabel._id

          this.contactsLabels.push(item)
          this.alert(res)
          this.closeModale();
        })
        .catch(err => this.alert(err))
      }
    },
    deleteLabel(id){
      // Côté client, les contacts avec ce label l'auront toujours, mais il ne sera plus affiché. Côté serveur, la requête va s'occuper de supprimer le label de tous les contacts en BDD en asynchrone
      this.$axios.delete('contactsLabels/'+ id)
      .then(res => {
        this.alert(res)
        //Supprimer l'élément chez le client aussi
        this.contactsLabels.splice(this.contactsLabels.findIndex(e => e._id == id), 1)
        this.closeModale();
      })
      .catch(err => this.alert(err))
    },
    openLabel(id){
      //Fermer le menu avant d'ouvrir la modale
      this.closeModale()

      let label = this.contactsLabels.find(e => e._id == id)

      this.modaleInfos._id = id
      this.modaleInfos.labelName = label.name
      this.modaleInfos.color = label.color
      this.isModaleUpdateLabelVisible = true
    },
    updateLabel(id){
      if (!this.modaleInfos.labelName){
        this.alert("Veuillez entrer un nom de label")
      } else {

        let item = this.contactsLabels.find(e => e._id == id)
        item.updated = Date.now()
        item.updatedBy = this.$store.state.auth.currentUser._id
        item.name = this.modaleInfos.labelName
        item.color = this.modaleInfos.color

        this.$axios.put('contactsLabels/' + id, item)
        .then(res => {
          // this.contactsLabels.splice(4, 1, );
          this.alert(res)
          this.closeModale();
        })
        .catch(err => this.alert(err))
      }
    },
    addLabelToContact(contactId, labelId){
      this.contact.labels.push(labelId)

      this.$axios.put('contacts/'+ contactId, this.contact)
      .then(res => {
        this.alert(res)
        // this.contacts.splice(this.contacts.findIndex(e => e._id == this.contact._id), 1, {...this.contact})
        // this.updateLoading = false
        this.closeModale()
      })
      .catch(err => this.alert(err))
    },
    deleteLabelFromContact(contactId, labelId){
      let index = this.contact.labels.indexOf(labelId)
      this.contact.labels.splice(index, 1)

      this.$axios.put('contacts/'+ contactId, this.contact)
      .then(res => {
        this.alert(res)
      })
      .catch(err => this.alert(err))

    },
    populateLabel(id){
      return this.contactsLabels.find(e => e._id == id)
    },
    selectLabel(id){
      this.contact = {} //Je dessélectionne le contact pour qu'il ne soit pas affiché alors qu'il ne fait pas partie de ce label
      this.selectedLabel = id

      if (id !== ""){
        this.contactsDisplayed = this.contacts.filter(e => e.labels.indexOf(id) !== -1)
      } else {
        this.contactsDisplayed = this.contacts
      }
    },
    dealWithResult(result){
      if (result == ""){
        this.contactsDisplayed = this.contacts
      } else if (result.length == 0){
        this.contactsDisplayed = []
      } else if (result.length == 1){
        this.contactsDisplayed = [this.contacts.find(e => e._id == result[0]._id)]
        this.contact = this.contacts.find(e => e._id == result[0]._id)
      } else {
        let myArray = []
        for (let item of result){
          myArray.push(this.contacts.find(e => e._id == item._id))
        }
        this.contactsDisplayed = myArray
        this.contact = {}
      }
    }
  }
}
</script>

<template>
    <div class="page-main">
      <Banner bannerImage="bannerEquipe"/>
      <div>
        <TabMenu>
          <template v-slot:body>
            <Tab text="Contacts"   route="/contacts"  customWidth=160 />
          </template>
        </TabMenu>

        <Modale v-if="isModaleAddContactVisible" @close="closeModale()">
          <template v-slot:header>
            <span>Créer un contact</span>
          </template>
          <template v-slot:body>
            <div class="modale-addContact">
              <span class="material-icons">perm_identity</span>
              <input type="text" placeholder="Prénom" id="prenom" @keypress="removeError('prenom')" v-model="modaleInfos.name">
              <span></span>
              <input type="text" placeholder="Nom" v-model="modaleInfos.surname">
              <span class="material-icons">alternate_email</span>
              <input type="email" placeholder="E-mail" v-model="modaleInfos.email">
              <span class="material-icons">phone</span>
              <div class="modale-addContact-double">
                <input type="tel" placeholder="Numéro de téléphone" v-model="modaleInfos.phone1" style="margin-right: 3px;" v-on:keypress="isNumeric">
                <input type="tel" placeholder="Libellé" v-model="modaleInfos.phone1Label">
              </div>
              <span></span>
              <div class="modale-addContact-double">
                <input type="tel" placeholder="Numéro de téléphone" v-model="modaleInfos.phone2" style="margin-right: 3px;" v-on:keypress="isNumeric">
                <input type="tel" placeholder="Libellé" v-model="modaleInfos.phone2Label">
              </div>
              <span class="material-icons">business</span>
              <input type="text" placeholder="Organisation" v-model="modaleInfos.organisation">
              <span></span>
              <input type="text" placeholder="Fonction dans l'organisation" v-model="modaleInfos.fonction">
              <span></span>
              <input type="text" placeholder="Adresse" v-model="modaleInfos.address">
              <span></span>
              <input type="text" placeholder="Code postal" v-model="modaleInfos.code">
              <span></span>
              <input type="text" placeholder="Ville" v-model="modaleInfos.city">
              <span></span>
              <input type="text" placeholder="N° Siret" v-model="modaleInfos.siret">
              <!-- <span class="material-icons">label</span>
              <select name="labels" id="labels">
                <option value="">Labels</option>
              </select> -->
              <span></span>
              <textarea rows="5" cols="60" name="comment" placeholder="Commentaires..." v-model="modaleInfos.comment"></textarea>
            </div>
          </template>
          <template v-slot:footer>
            <ModalYesNo @yes="addContact" @no="closeModale"></ModalYesNo>
          </template>
        </Modale>

        <Modale v-if="isModaleDeleteVisible" @close="closeModale()">
          <template v-slot:header>
            <span>Supprimer ce contact ?</span>
          </template>
          <template v-slot:body>
            <div>Vous êtes sur le point de supprimer ce contact. Cette action est irréversible, êtes vous sûr ?</div>
          </template>
          <template v-slot:footer>
            <ModalYesNo @yes="deleteContact(contact._id)" @no="closeModale()"></ModalYesNo>
          </template>
        </Modale>

        <Modale v-if="isModaleCreateLabelVisible" @close="closeModale()">
          <template v-slot:header>
            <span>Créer un label</span>
          </template>
          <template v-slot:body>
            <div class="modale-addLabel">
              <span class="material-icons">perm_identity</span>
              <input type="text" placeholder="Label" id="labelName" v-model="modaleInfos.labelName">
              <span class="material-icons">palette</span>
              <input type="color" placeholder="color" v-model="modaleInfos.color">
            </div>
          </template>
          <template v-slot:footer>
            <ModalYesNo @yes="addLabel()" @no="closeModale()"></ModalYesNo>
          </template>
        </Modale>

        <Modale v-if="isModaleUpdateLabelVisible" @close="closeModale()">
          <template v-slot:header>
            <span>Modifier le label {{ modaleInfos.labelName }}</span>
          </template>
          <template v-slot:body>
            <div class="modale-addLabel">
              <span class="material-icons">perm_identity</span>
              <input type="text" placeholder="Label" id="labelName" v-model="modaleInfos.labelName">
              <span class="material-icons">palette</span>
              <input type="color" placeholder="color" v-model="modaleInfos.color">
            </div>
          </template>
          <template v-slot:footer>
            <ModalYesNo @yes="updateLabel(modaleInfos._id)" @no="closeModale()"></ModalYesNo>
          </template>
        </Modale>

        <Modale v-if="isModaleDeleteLabelVisible" @close="closeModale()">
          <template v-slot:header>
            <span>Supprimer le label {{ modaleInfos.name }}</span>
          </template>
          <template v-slot:body>
            <div>
              <span>Vous êtes sur le point de supprimer le label {{modaleInfos.name}}. Cette action est irréversible, êtes vous sûr ?</span>
            </div>
          </template>
          <template v-slot:footer>
            <ModalYesNo @yes="deleteLabel(modaleInfos._id)" @no="closeModale()"></ModalYesNo>
          </template>
        </Modale>

        <div class="page-main-container" v-if="fullyLoaded">
          <button class="addContact" @click="isModaleAddContactVisible = true">
            <div><span class="material-icons addContact-icon">person_add</span></div>
            <div>Créer un nouveau contact</div>
          </button>
          <SearchPredictive class="search" borderRadius="5px" :placeholder="'Rechercher...'" :arraySearch="arrayForSearch" @result="dealWithResult"/>
          <!-- <div class="search">
            <input class="search-input" type="search" :placeholder="searchPlaceholder">
            <Menu class="search-menu">
              <template v-slot:body>
                <div>plop</div>
                <div>plop</div>
                <div>plop</div>
              </template>
            </Menu>
          </div> -->

          <!------------------------->
          <!-- Menu latéral Gauche -->
          <!------------------------->
          <div class="menuAside">
            <div class="menuAside-add" @click="selectLabel('')">
              <span class="material-icons menuAside-add-addIcon">person_outline</span>
              <span>Tous les contacts ({{contacts.length}})</span>
            </div>
            <div class="menuAside-title">Labels</div>
            <div class="menuAside-item" v-for="item in contactsLabels" :key="item._id">
              <div class="menuAside-item-survol">
                <div class="menuAside-item-survol-clickableField" @click="selectLabel(item._id)"></div>
                <span class="material-icons"  @click="showLabelMenu(item._id)">more_vert</span>
              </div>
              <span class="material-icons menuAside-item-labelIcon" :style="'color:' + item.color">label</span>
              {{item.name}}
              <Menu class="menuAside-item-menu" v-if="isLabelMenuVisible._id == item._id" @close="isLabelMenuVisible._id=''" width="150px">
                <template v-slot:body>
                  <div @click="isModaleDeleteLabelVisible = true; modaleInfos = item"><span class="material-icons menuAside-item-menu-icon">delete</span>Supprimer</div>
                  <div @click="openLabel(item._id)"><span class="material-icons menuAside-item-menu-icon">edit</span>Renommer</div>
                  <div @click="openLabel(item._id)"><span class="material-icons menuAside-item-menu-icon">palette</span>Modifier la couleur</div>
                </template>
              </Menu>
            </div>
            <div class="menuAside-separator"></div>
            <div class="menuAside-add" @click="createLabel()">
              <span class="material-icons menuAside-add-addIcon">add</span>
              <span>Créer un label</span>
            </div>
          </div>

          <!------------------------>
          <!-- Tableau au centre  -->
          <!------------------------>
          <div class="tableau">
            <div class="tableau-legende">
              <div>Contact</div>
              <div>Organisation</div>
              <div>Téléphone principal</div>
            </div>
            <div v-for="item in contactsDisplayed" :key="item._id" class="tableau-item" @click="selectContact(item._id)">
              <div class="tableau-item-survol">
                <!-- <span class="material-icons">more_vert</span> -->
              </div>
              <div>
                <div class="tableau-item-title">{{item.name}} {{item.surname}}</div>
                <!-- <div>{{item._id}}</div> -->
                <div>{{item.email}}</div>
              </div>
              <div>{{item.organisation}}</div>
              <div>{{item.phone1}} <span v-if="item.phone1Label">({{item.phone1Label}})</span></div>
            </div>
          </div>

          <!------------------------>
          <!--      Détails       -->
          <!------------------------>
          <!-- Si l'object contact a au moins une propriété -->
          <div class="detail" v-if="Object.values(contact).length">
            <div class="detail-header">
              <div class="detail-header-infos">
                <div class="detail-header-infos-title">{{contact.name}} {{contact.surname}}</div>
                <div class="detail-header-infos-organisation">{{contact.organisation}}</div>
              </div>
              <div class="detail-header-avatar">
                <div class="detail-header-avatar-letter">{{contact.name.substr(0, 1)}}</div>
              </div>
              <div class="detail-header-labels">
                <span class="material-icons" v-if="labelsInAddMenu.length > 0" @click="isAddLabelToContactMenuVisible = true">label</span>
                <span class="material-icons" v-else>label</span>
                <Menu class="detail-header-labels-menu" v-if="isAddLabelToContactMenuVisible" @close="isAddLabelToContactMenuVisible = false" width="250px">
                  <template v-slot:body>
                    <div v-for="label in labelsInAddMenu" :key="label._id" @click="addLabelToContact(contact._id, label._id)">
                      <span class="material-icons" :style="'color:' + label.color">label</span>
                      <span class="detail-header-labels-menu-text">{{label.name}}</span>
                    </div>
                  </template>
                </Menu>
                <div class="detail-header-labels-none" v-if="!contact.labels || contact.labels.length == 0">Aucun label associé</div>
                <div v-else>
                  <div v-for="label in contact.labels" :key="label" class="detail-header-labels-list">
                    <!-- Le v-if permet d'élminer les labels qui seraient encore associés au contact alors qu'ils n'existent plus dans la liste des label de cette agence. -->
                    <div v-if="populateLabel(label)" class="detail-header-labels-list-item" :style="'border-color:' + populateLabel(label).color + '; background-color:' + populateLabel(label).color + '40;'">
                      <div class="detail-header-labels-list-item-text">{{ populateLabel(label).name }}</div>
                      <div class="detail-header-labels-list-item-close" :style="'border-color:' + populateLabel(label).color + ';'" @click="deleteLabelFromContact(contact._id, label)">x</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-body">
              <span class="material-icons">perm_identity</span>
              <input type="text" placeholder="Prénom" v-model="contact.name">
              <span></span>
              <input type="text" placeholder="Nom" v-model="contact.surname">
              <span class="material-icons">alternate_email</span>
              <input type="email" placeholder="E-mail" v-model="contact.email">
              <span class="material-icons">phone</span>
              <input type="tel" placeholder="Numéro de téléphone" v-model="contact.phone1" v-on:keypress="isNumeric">
              <span></span>
              <input type="tel" placeholder="Libellé" v-model="contact.phone1Label">
              <span></span>
              <input type="tel" placeholder="Numéro de téléphone" v-model="contact.phone2" v-on:keypress="isNumeric">
              <span></span>
              <input type="tel" placeholder="Libellé" v-model="contact.phone2Label">
              <span class="material-icons">business</span>
              <input type="text" placeholder="Organisation" v-model="contact.organisation">
              <span></span>
              <input type="text" placeholder="Fonction dans l'organisation" v-model="contact.fonction">
              <span></span>
              <input type="text" placeholder="Adresse" v-model="contact.address">
              <span></span>
              <input type="text" placeholder="Code postal" v-model="contact.code">
              <span></span>
              <input type="text" placeholder="Ville" v-model="contact.city">
              <span></span>
              <input type="text" placeholder="N° Siret" v-model="contact.siret">
              <!-- <span class="material-icons">label</span>
              <select name="labels" id="labels">
                <option value="">Labels</option>
              </select> -->
              <span></span>
              <textarea rows="3" cols="20" name="comment" placeholder="Commentaires..." v-model="contact.comment"></textarea>
            </div>
            <div class="detail-footer">
              <div class="detail-footer-line"></div>
              <div class="detail-footer-container">
                <!-- <div id="updateContactButton" class="detail-footer-container-bouton detail-footer-container-bouton-unchanged">Enregistrer</div> -->
                <ButtonWithLoading text="Enregistrer" color="green" :active="!contactObserver" :loading="updateLoading" @clicked="updateContact(contact._id)" width="80px" />
                <div class="detail-footer-container-blank"></div>
                <span class="material-icons" @click="isModaleDeleteVisible = true">delete</span>
                <!-- <span class="material-icons" @click="test(contact)">file_download</span> -->
              </div>
            </div>
          </div>
          <div class="detail" v-else>
            <p>Sélectionnez un contact pour le visualiser ou le modifier.</p>
          </div>
        </div>
        <Spinner v-else/>
      </div>

      <Footer/>
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;
.page-main-container{
  @include grid-alpha;
}

.addContact{
  grid-column: 1;
  grid-row: 1;
  @include myButton;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  &-icon{
    margin: 0 10px 0 0;
    color: white;

    &:hover{
      color: white;
    }
  }
}

.search{
  grid-column: 2 / span 2;
  @include myBackBlock;
}

.menuAside{
  grid-column: 1;
  grid-row: 2 / span 1;
  @include myBlock;
  padding: 15px;

  &-title{
    @include myFont;
    color: $main;
    font-size: 13px;
    font-weight: 600;
    margin: 25px 0 15px 0;
  }

  &-item{
    @include myFont;
    font-size: 13px;
    display: flex;
    align-items: center;
    position: relative;
    padding: 2px 0;

    &-labelIcon{
      margin: 0 7px 0 0;
    }

    &:hover .menuAside-item-survol{
      visibility: visible;
    }

    &-survol{
      background-color: rgba($color: $main, $alpha: 0.05);
      position: absolute;
      width: 100%;
      height: 100%;
      visibility: hidden;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 3px 0 0;
      box-sizing: border-box;
      border-radius: 5px;
      cursor: pointer;

      &-clickableField{
        height: 100%;
        flex: 1;
      }
    }

    &-menu{
      left: 180px;
      top: 25px;
    }
  }

  &-separator{
    border-top: $black-light solid 1px;
    margin: 15px 0;
  }

  &-add{
    display: flex;
    align-items: center;
    @include myFont;
    font-size: 13px;
    border-radius: 5px;
    cursor: pointer;

    &:hover{
      background-color: rgba($color: $main, $alpha: 0.05);
    }

    &-addIcon{
      margin: 0 7px 0 0;
    }
  }

}

.tableau{
  grid-column: 2 / span 2;
  grid-row: 2 / span 3;
  @include myBlock;

  &-legende{
    @include myFont;
    font-size: 11px;
    color: $black-bold;
    display: grid;
    // grid-template-columns: 1.5fr repeat(2, 1fr) 50px 20px;  //A caler sur item
    grid-template-columns: 1.5fr repeat(2, 1fr); //En attendant...
    padding: 10px 10px; //idem
    column-gap: 15px; //idem
  }

  &-item{
    display: grid;
    // grid-template-columns: 1.5fr repeat(2, 1fr) 50px 20px; //Modifier la légende également - les 50px c'est pour les pastilles de couleur des labels - les 20px pour les trois petits points du menu
    grid-template-columns: 1.5fr repeat(2, 1fr); //En attendant...
    column-gap: 15px;
    border-bottom: $black-light 1px solid;
    padding: 5px 10px;
    position: relative;
    cursor: pointer;

    &:hover .tableau-item-survol{
      visibility: visible;
    }

    &-survol{
      background-color: rgba($color: $main, $alpha: 0.05);
      position: absolute;
      width: 100%;
      height: 100%;
      visibility: hidden;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 3px 0 0;
      box-sizing: border-box;
    }

    & div{
      align-self: center;
      @include myFont;
      font-size: 13px;
      @include monoline;
    }

    &-title{
      color: $main;
      font-weight: 600;
    }
  }
}

.detail{
  grid-column: 4;
  grid-row: 2 / span 2;
  @include myBlock;
  padding: 15px;
  // position: relative;

  & p{
    padding: 15px;
    width: 100%;
    text-align: center;
    @include myFont;
    color: $black-light;
    box-sizing: border-box;
  }

  &-header{
    display: grid;
    grid-template-columns: 1fr 50px;
    grid-template-rows: 50px auto;
    margin-bottom: 15px;
    min-height: 100px;

    &-avatar{
      background-color: $main-lighter;
      height: 50px;
      min-width: 50px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &-letter{
        color: white;
        @include myFont;
        font-size: 30px;
      }
    }

    &-infos{
      @include myFont;
      @include monoline;

      &-title{
        color: $main;
        @include monoline;
        font-weight: 600;
        font-size: 18px;
      }

      &-organisation{
        font-size: 14px;
        @include monoline;
        margin-top: 5px;
      }
    }

    &-labels{
      margin-top: 15px;
      position: relative;
      display: flex;
      @include myFont;
      grid-column: 1 / span 2;

      &-menu{
        position: absolute;
        left: 30px;
        top: -14px;

        &-text{
          font-size: 13px;
        }
      }

      &-none{
        color: $black-light;
        font-size: 13px;
        margin: 3px 0 0 5px;
      }

      &-list{
        display: inline-block;

        &-item{
          border: 1px solid;
          display: inline-block;
          font-size: 11px;
          margin: 0 2px;
          border-radius: 3px;

          &-text{
            display: inline-block;
            padding: 1px 5px;
            cursor: default;
          }

          &-close{
            display: inline-block;
            border-left: 1px solid;
            padding: 1px 4px;
            cursor: pointer;
          }
        }
      }
    }
  }

  &-body{
    display: grid;
    grid-template-columns: 20px 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 5px;

    &-double{
      width: 100%;
      display: flex;

      & input{
        flex: 1;
      }
    }
  }

  &-footer{
    &-line{
      border-top: $black-light solid 1px;
      margin: 15px 0;
    }

    &-container{
      display: flex;
      margin-left: 40px;
      align-items: center;

      &-bouton{
        @include myButton;
        font-size: 13px;
        background-color: $green;

        &-unchanged{
          background-color: $black-light;
          cursor: default;

          &:hover{
            box-shadow: none;
          }
        }
      }

      &-blank{
        flex: 1;
      }
    }
  }
}

.modale{
  &-addContact{
    display: grid;
    grid-template-columns: 20px 420px;
    grid-column-gap: 20px;
    grid-row-gap: 5px;

    &-double{
      width: 100%;
      display: flex;

      & input{
        flex: 1;
      }
    }
  }

  &-addLabel{
    display: grid;
    grid-template-columns: 20px 150px;
    grid-column-gap: 20px;
    grid-row-gap: 5px;
  }
}

.error{
  color: $alert;
  border-color: $alert;
  background-color: $alert-lighter;
}

</style>
